import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import useIsInappWebview from "./useIsInappWebview";
import { sendMessage } from "utils/webview";
import { userAtom } from "recoil/userAtom";
import { patientAtom } from "recoil/patientAtom";

export default function useOpenTask({
  taskKey,
  thoughtRecordKey,
  meditationRecordKey,
}: {
  taskKey: string;
  thoughtRecordKey?: string;
  meditationRecordKey?: string;
}) {
  const navigate = useNavigate();
  const isInappWebview = useIsInappWebview();
  const user = useRecoilValue(userAtom);
  const patientState = useRecoilValue(patientAtom);
  const pid = patientState?.patientId;

  const encodedTaskKey = encodeURIComponent(taskKey);
  const newPathName = `/${encodedTaskKey}`;

  function goTask() {
    if (window.location.pathname === newPathName || !isInappWebview) {
      navigate(
        `${newPathName}${thoughtRecordKey ? `?trk=${thoughtRecordKey}` : meditationRecordKey ? `?mrk=${meditationRecordKey}` : ``}`,
        { replace: window.location.pathname === newPathName }
      );
    } else {
      if (isInappWebview) {
        if (taskKey === "payment") {
          sendMessage(
            JSON.stringify({
              event: "open_modal",
              params: {
                url: `${window.location.origin}/payment`,
                type: "transparentModal",
              },
            })
          );
        } else {
          const url = `${window.location.origin}${newPathName}?at=${
            user?.accessToken
          }${pid ? `&pid=${pid}` : ``}${
            thoughtRecordKey
              ? `&trk=${thoughtRecordKey}`
              : meditationRecordKey
                ? `&mrk=${meditationRecordKey}`
                : `&ts=${Date.now().toString()}`
          }`;

          sendMessage(
            JSON.stringify({
              event: "navigate",
              params: {
                url: url,
              },
            })
          );
        }
      }
    }
  }

  return goTask;
}
